<template>
    <div class="serviceDetailContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>开发详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 商品信息 -->
        <div class="serviceDetailBox spb">
            <div class="serviceDetailLeft">
                <div class="detailBox spb">
                    <div class="detailImgBox">
                        <el-image v-if="serviceDetailData.img" :src="serviceDetailData.img" fit="cover" class="detailImg" style="width: 160px;"></el-image>
                        <div class="sell">已售: {{ serviceDetailData.sales }}</div>
                    </div>
                    <div class="detailData">
                        <div class="title">{{ serviceDetailData.name }}</div>
                        <div class="introduce">{{ serviceDetailData.name1 }}</div>
                        <div class="priceBox align">
                            <div class="price"><span>￥</span>{{ serviceDetailData.price }}</div>
                        </div>
                        <div class="specBox flex">
                            <div class="specTitle">说明</div>
                            <div class="tips">{{ serviceDetailData.shuoming }}</div>
                        </div>
                        <!-- <div class="specBox flex">
                            <div class="specTitle">规格</div>
                            <div class="specList flex">
                                <div :class="['spec',serviceDetailData.active == index ? 'specOn' : '']" v-for="(item,index) in serviceDetailData.spec" @click="serviceDetailData.active = index" :title="item.spec_name">{{ item.spec_name }}</div>
                            </div>
                        </div> -->
                        <div class="specBox flex">
                            <div class="specTitle">数量</div>
                            <el-input-number v-model="num" :step="1" step-strictly @change="handleChange" :min="1" size="small"></el-input-number>
                        </div>
                        <div class="detailBtn" @click="detailBtnTap">立即购买</div>
                    </div>
                </div>
                <!-- 详情图 -->
                <div class="detailBox">
                    <div class="courseTabBox align">
                        <div :class="['courseTab',active == index ? 'courseTabOn' : '']" v-for="(item,index) in courseTabData" :key="index" @click="courseTabTap(index)">{{ item }}</div>
                    </div>
                    <div class="courseImgBox">
                        <div v-html="active == '0' ? serviceDetailData.detail : active == '1' ? serviceDetailData.jiaocheng : ''"></div>
                    </div>
                </div>
            </div>
            <div class="serviceDetailRight">
                <div class="contactContent">
                    <div class="contactHi">Hi,联系专属客服</div>
                    <div class="contactTitle">为您寻找最适合的产品解决方案</div>
                    <div class="contactBox column">
                        <el-image :src="kefu" class="contactImg"></el-image>
                        <div class="contactTips">扫码添加客服微信</div>
                    </div>
                </div>
                <div class="relatedList">
                    <div class="relatedTop">相关推荐</div>
                    <div class="relatedBox spb" v-for="(item,index) in related" :key="index" @click="relatedTap(item.id)">
                        <el-image :src="item.img" fit="cover" class="relatedImg" style="width:55px;"></el-image>
                        <div class="relatedData" style="width: 179px;">
                            <div class="relatedTtile">{{ item.name }}</div>
                            <div class="relatedPrice">￥{{ item.price }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                userDetail: 0,
                num: 1,
                serviceDetailData: {},
                kefu: '',
                related: [],
                active: 0,
                courseTabData: ['服务详情','使用教程'],
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getGoodsDetail()
        },
        methods: {
            // 获取商品详情
            getGoodsDetail(){
                this.request.get("index/kaifa/info",{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    res.data.active = 0
                    this.serviceDetailData = res.data.info
                    this.kefu = res.data.kefu
                    this.related = res.data.xiangguan
                })
            },
            // 数量加减
            handleChange(value) {
                console.log(value);
            },
            // tab切换
            courseTabTap(e){
                this.active = e
                console.log(this.$route.params.id)
            },
            // 相关推荐
            relatedTap(e){
                let that = this
                this.$router.replace({
                path: "/develop/detail",
                query: {id: e}
                },()=>{
                    this.$router.go(0)//刷新页面
                })
            },
            // 跳转提交表单
            detailBtnTap(){
                if(!this.userDetail){
                    this.$router.push({ path:'/login/login' })
                    return
                }
                this.$router.push({ path:'/service/form', query:{id:this.$route.query.id,type: '1',num:this.num} })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/detail.less';
</style>